// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { SYSTEM } from '../internal/environment';
import customCssProps from '../internal/generated/custom-css-properties';
export function getRootStyles(style) {
    var _a, _b, _c, _d, _e;
    if (SYSTEM !== 'core') {
        return {};
    }
    return {
        ...(((_a = style === null || style === void 0 ? void 0 : style.root) === null || _a === void 0 ? void 0 : _a.background) && { [customCssProps.styleItemCardBackgroundDefault]: style.root.background }),
        ...(((_b = style === null || style === void 0 ? void 0 : style.root) === null || _b === void 0 ? void 0 : _b.borderRadius) && {
            [customCssProps.styleItemCardBorderRadius]: style.root.borderRadius,
            borderRadius: style.root.borderRadius,
        }),
        ...(((_c = style === null || style === void 0 ? void 0 : style.root) === null || _c === void 0 ? void 0 : _c.borderColor) && { [customCssProps.styleItemCardBorderColorDefault]: style.root.borderColor }),
        ...(((_d = style === null || style === void 0 ? void 0 : style.root) === null || _d === void 0 ? void 0 : _d.borderWidth) && { [customCssProps.styleItemCardBorderWidthDefault]: style.root.borderWidth }),
        ...(((_e = style === null || style === void 0 ? void 0 : style.root) === null || _e === void 0 ? void 0 : _e.boxShadow) && { [customCssProps.styleItemCardBoxShadowDefault]: style.root.boxShadow }),
    };
}
export function getContentStyles(style) {
    var _a, _b;
    if (SYSTEM !== 'core') {
        return {};
    }
    return {
        ...(((_a = style === null || style === void 0 ? void 0 : style.content) === null || _a === void 0 ? void 0 : _a.paddingBlock) && { paddingBlock: style.content.paddingBlock }),
        ...(((_b = style === null || style === void 0 ? void 0 : style.content) === null || _b === void 0 ? void 0 : _b.paddingInline) && { paddingInline: style.content.paddingInline }),
    };
}
export function getHeaderStyles(style) {
    var _a, _b;
    if (SYSTEM !== 'core') {
        return {};
    }
    return {
        ...(((_a = style === null || style === void 0 ? void 0 : style.header) === null || _a === void 0 ? void 0 : _a.paddingBlock) && { paddingBlock: style.header.paddingBlock }),
        ...(((_b = style === null || style === void 0 ? void 0 : style.header) === null || _b === void 0 ? void 0 : _b.paddingInline) && { paddingInline: style.header.paddingInline }),
    };
}
export function getFooterStyles(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (SYSTEM !== 'core') {
        return {};
    }
    const hasDivider = ((_b = (_a = style === null || style === void 0 ? void 0 : style.footer) === null || _a === void 0 ? void 0 : _a.divider) === null || _b === void 0 ? void 0 : _b.borderColor) || ((_d = (_c = style === null || style === void 0 ? void 0 : style.footer) === null || _c === void 0 ? void 0 : _c.divider) === null || _d === void 0 ? void 0 : _d.borderWidth);
    return {
        ...(hasDivider && { borderBlockStartStyle: 'solid' }),
        ...(((_f = (_e = style === null || style === void 0 ? void 0 : style.footer) === null || _e === void 0 ? void 0 : _e.divider) === null || _f === void 0 ? void 0 : _f.borderColor) && { borderBlockStartColor: style.footer.divider.borderColor }),
        ...(((_h = (_g = style === null || style === void 0 ? void 0 : style.footer) === null || _g === void 0 ? void 0 : _g.divider) === null || _h === void 0 ? void 0 : _h.borderWidth) && { borderBlockStartWidth: style.footer.divider.borderWidth }),
        ...(((_k = (_j = style === null || style === void 0 ? void 0 : style.footer) === null || _j === void 0 ? void 0 : _j.root) === null || _k === void 0 ? void 0 : _k.paddingBlock) && { paddingBlock: style.footer.root.paddingBlock }),
        ...(((_m = (_l = style === null || style === void 0 ? void 0 : style.footer) === null || _l === void 0 ? void 0 : _l.root) === null || _m === void 0 ? void 0 : _m.paddingInline) && { paddingInline: style.footer.root.paddingInline }),
    };
}
//# sourceMappingURL=style.js.map